import { l10n } from '../i18n/i18nUtil';
export function textDuration(millis) {
    if (millis >= 1000) {
        var seconds = millis / 1000;
        if (seconds >= 60) {
            var minutes = seconds / 60;
            if (minutes >= 60) {
                var hours = minutes / 60;
                return l10n('textDuration.hours', [
                    Math.floor(hours),
                    Math.floor((hours - Math.floor(hours)) * 60)
                ]);
            }
            else {
                return l10n('textDuration.minutes', [
                    Math.floor(minutes),
                    Math.floor((minutes - Math.floor(minutes)) * 60)
                ]);
            }
        }
        else {
            return l10n('textDuration.seconds', [
                Math.floor(seconds)
            ]);
        }
    }
    else {
        return l10n('textDuration.milliSeconds', [
            Math.floor(millis)
        ]);
    }
}
